import { useEffect, useState } from "react";
import Api from "../../../components/api/Api";

export default function useUserDetails(userId) {
  const [userDetails, setUserDetails] = useState({});
  const getDetailsApi = Api({ url: `admin/user/id/${userId}` });

  const fetchUserDetails = async () => {
    try {
      const res = await getDetailsApi.fetchData();
      setUserDetails(res?.data?.user || {});
    } catch (err) {
      console.error("User detail error:", err);
    }
  };

  useEffect(() => {
    if (userId) fetchUserDetails();
  }, [userId]);

  return userDetails;
}
